module.exports = __webpack_public_path__ + "img/physio_ot_splash.5293c361.jpg";